module.exports = __webpack_public_path__ + "img/add_info.87dc09e5.png";